/* eslint-disable @next/next/no-img-element */
"use client";

import { LinkCard } from "@/components/common/link-card";
import {
	Carousel,
	CarouselContent,
	CarouselItem,
	CarouselNext,
	CarouselPrevious,
} from "@/components/new/carousel";
import { cn, formatImageUrl, linkToVideoEmbedURL } from "@/lib/utils";
import { TPostLink, TPostMedia } from "@/types/post";
import { ChevronLeftIcon, ChevronRightIcon } from "lucide-react";

type FeedPostCarouselProps = {
	images: TPostMedia[];
	links: TPostLink[];
	className?: string;
	fullScreen?: boolean;
	onImageClick?: (index: number) => void;
	startIndex?: number;
};

const carouselClasses = {
	base: "absolute top-1/2 -translate-y-1/2",
	prev: "left-2",
	next: "right-2",
};

const FeedMediaCarouselUi = ({
	links,
	images,
	className,
	fullScreen,
	onImageClick,
}: FeedPostCarouselProps) => {
	if (links.length === 0 && images.length === 0) return null;

	const videoLinks = links.filter(({ url }) => !!linkToVideoEmbedURL(url));
	const linkCards = links.filter(({ url }) => !linkToVideoEmbedURL(url));

	return (
		<Carousel className={className}>
			<CarouselContent>
				{videoLinks.map((item, i) => {
					return (
						<CarouselItem
							key={i}
							id="hola"
							className={cn(
								"flex h-96 w-full justify-center px-4 md:px-16",
								fullScreen && "h-auto max-h-[90%]"
							)}
						>
							<LinkCard
								link={item}
								size={"free"}
								className={cn("m-auto h-full w-auto", fullScreen && "h-auto w-full")}
							/>
						</CarouselItem>
					);
				})}
				{images.map((item, i) => {
					return (
						<CarouselItem
							key={i}
							className={cn(
								"flex h-96 w-full cursor-pointer flex-row justify-center rounded-md bg-transparent",
								fullScreen && "h-auto max-h-[50%] cursor-default"
							)}
							onClick={() => onImageClick?.(i)}
						>
							<img
								src={formatImageUrl(item.objectPath)}
								alt={item.alt ?? "image"}
								className={cn("m-auto h-full object-contain", !fullScreen && "w-full")}
							/>
						</CarouselItem>
					);
				})}
				{linkCards.map((item, i) => {
					return (
						<CarouselItem
							key={i}
							id="hola"
							className={cn(
								"flex h-96 w-full justify-center px-4 md:px-16",
								fullScreen && "h-auto max-h-[90%]"
							)}
						>
							<LinkCard
								link={item}
								size={"free"}
								className={cn("m-auto h-full w-auto", fullScreen && "h-auto w-full")}
							/>
						</CarouselItem>
					);
				})}
			</CarouselContent>

			{links.length + images.length > 1 && (
				<>
					<CarouselPrevious
						className={cn(
							carouselClasses.base,
							carouselClasses.prev,
							"bg-black/50 text-gray-50 hover:bg-black/70 hover:text-white",
							links.length + images.length === 1 && "hidden"
						)}
					>
						<ChevronLeftIcon className="h-6 w-6" />
					</CarouselPrevious>

					<CarouselNext
						className={cn(
							carouselClasses.base,
							carouselClasses.next,
							"bg-black/50 text-gray-50 hover:bg-black/70 hover:text-white",
							links.length + images.length === 1 && "hidden"
						)}
					>
						<ChevronRightIcon className="h-6 w-6" />
					</CarouselNext>
				</>
			)}
		</Carousel>
	);
};

export default FeedMediaCarouselUi;
